import { shape, number, string } from 'prop-types';

export const contactType = shape({
  contactNum: number,
  countryCode: string,
  firstName: string,
  lastName: string,
  locale: string,
  phone: string,
  seqNum: number,
  user_id: number,
});
